(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'experiment-evaluation-evaluation-core'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'experiment-evaluation-evaluation-core'.");
    }
    root['experiment-evaluation-evaluation-core'] = factory(typeof this['experiment-evaluation-evaluation-core'] === 'undefined' ? {} : this['experiment-evaluation-evaluation-core'], this['kotlin-kotlin-stdlib-js-ir']);
  }
}(this, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var hashCode = kotlin_kotlin.$_$.z;
  var THROW_CCE = kotlin_kotlin.$_$.n1;
  var equals = kotlin_kotlin.$_$.w;
  var classMeta = kotlin_kotlin.$_$.u;
  var setMetadataFor = kotlin_kotlin.$_$.e1;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.d;
  var Unit_getInstance = kotlin_kotlin.$_$.i;
  var Map = kotlin_kotlin.$_$.k;
  var isInterface = kotlin_kotlin.$_$.b1;
  var Long = kotlin_kotlin.$_$.m1;
  var toLong = kotlin_kotlin.$_$.f1;
  var contains = kotlin_kotlin.$_$.m;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.e;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.h;
  var encodeToByteArray = kotlin_kotlin.$_$.i1;
  var charSequenceLength = kotlin_kotlin.$_$.t;
  var objectMeta = kotlin_kotlin.$_$.d1;
  var getStringHashCode = kotlin_kotlin.$_$.y;
  var println = kotlin_kotlin.$_$.r;
  var rotateLeft = kotlin_kotlin.$_$.p1;
  var Enum = kotlin_kotlin.$_$.k1;
  var IllegalArgumentException = kotlin_kotlin.$_$.l1;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.g;
  var hashSetOf = kotlin_kotlin.$_$.n;
  var to = kotlin_kotlin.$_$.r1;
  var mapOf = kotlin_kotlin.$_$.o;
  var toString = kotlin_kotlin.$_$.q1;
  var toString_0 = kotlin_kotlin.$_$.g1;
  var removeSurrounding = kotlin_kotlin.$_$.j1;
  var startsWith$default = kotlin_kotlin.$_$.b;
  var Collection = kotlin_kotlin.$_$.j;
  var contains_0 = kotlin_kotlin.$_$.h1;
  var endsWith$default = kotlin_kotlin.$_$.a;
  var compareTo = kotlin_kotlin.$_$.v;
  var getNumberHashCode = kotlin_kotlin.$_$.x;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Allocation, 'Allocation', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(EvaluationEngineImpl, 'EvaluationEngineImpl', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Companion, 'Companion', objectMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(EvaluationResult, 'EvaluationResult', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(FlagConfig, 'FlagConfig', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(FlagResult, 'FlagResult', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Logger, 'Logger', objectMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Murmur3, 'Murmur3', objectMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Operator, 'Operator', classMeta, Enum, undefined, undefined, undefined, []);
  setMetadataFor(ParentDependencies, 'ParentDependencies', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(SegmentTargetingConfig, 'SegmentTargetingConfig', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Keys, 'Keys', objectMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(SkylabUser, 'SkylabUser', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(StringMatchColumnFilter, 'StringMatchColumnFilter', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(UserPropertyFilter, 'UserPropertyFilter', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(Variant, 'Variant', classMeta, undefined, undefined, undefined, undefined, []);
  setMetadataFor(VariantDistribution, 'VariantDistribution', classMeta, undefined, undefined, undefined, undefined, []);
  //endregion
  function Allocation(percentage, weights) {
    this.a7_1 = percentage;
    this.b7_1 = weights;
  }
  Allocation.prototype.toString = function () {
    return 'Allocation(percentage=' + this.a7_1 + ', weights=' + this.b7_1 + ')';
  };
  Allocation.prototype.hashCode = function () {
    var result = this.a7_1;
    result = imul(result, 31) + (this.b7_1 == null ? 0 : hashCode(this.b7_1)) | 0;
    return result;
  };
  Allocation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Allocation))
      return false;
    var tmp0_other_with_cast = other instanceof Allocation ? other : THROW_CCE();
    if (!(this.a7_1 === tmp0_other_with_cast.a7_1))
      return false;
    if (!equals(this.b7_1, tmp0_other_with_cast.b7_1))
      return false;
    return true;
  };
  function getVariantDistribution(_this__u8e3s4, variants) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var distribution = tmp$ret$0;
    var totalWeight = getTotalWeightForVariants(_this__u8e3s4, variants);
    if (totalWeight.equals(new Long(0, 0))) {
      var pct = 1.0 / variants.c();
      var inductionVariable = 0;
      var last = variants.c() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          distribution.a(new VariantDistribution(variants.f(i), pct, (i + 1 | 0) * pct));
        }
         while (inductionVariable <= last);
    } else {
      var cumulativeWeight = 0;
      var cumulativePct = 0.0;
      var tmp1_iterator = variants.d();
      while (tmp1_iterator.g()) {
        var variant = tmp1_iterator.e();
        var pct_0 = 0.0;
        var tmp2_safe_receiver = _this__u8e3s4.b7_1;
        var tmp;
        if (tmp2_safe_receiver == null) {
          tmp = null;
        } else {
          var tmp$ret$1;
          // Inline function 'kotlin.collections.get' call
          var tmp0_get = variant.c7_1;
          tmp$ret$1 = ((!(tmp2_safe_receiver == null) ? isInterface(tmp2_safe_receiver, Map) : false) ? tmp2_safe_receiver : THROW_CCE()).b1(tmp0_get);
          tmp = tmp$ret$1;
        }
        var tmp3_elvis_lhs = tmp;
        var variantRolloutWeight = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
        if (variantRolloutWeight > 0) {
          cumulativeWeight = cumulativeWeight + variantRolloutWeight | 0;
          pct_0 = variantRolloutWeight / totalWeight.i6();
          cumulativePct = cumulativeWeight / totalWeight.i6();
        }
        distribution.a(new VariantDistribution(variant, pct_0, cumulativePct));
      }
    }
    return distribution;
  }
  function getTotalWeightForVariants(_this__u8e3s4, variants) {
    var totalWeight = new Long(0, 0);
    if (!(_this__u8e3s4.b7_1 == null)) {
      var tmp0_iterator = variants.d();
      while (tmp0_iterator.g()) {
        var variant = tmp0_iterator.e();
        var tmp$ret$1;
        // Inline function 'kotlin.Long.plus' call
        var tmp2_plus = totalWeight;
        var tmp$ret$0;
        // Inline function 'kotlin.collections.get' call
        var tmp0_get = _this__u8e3s4.b7_1;
        var tmp1_get = variant.c7_1;
        tmp$ret$0 = ((!(tmp0_get == null) ? isInterface(tmp0_get, Map) : false) ? tmp0_get : THROW_CCE()).b1(tmp1_get);
        var tmp1_elvis_lhs = tmp$ret$0;
        var tmp3_plus = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        tmp$ret$1 = tmp2_plus.o6(toLong(tmp3_plus));
        totalWeight = tmp$ret$1;
      }
    }
    return totalWeight;
  }
  function scaled($this, pct, max) {
    var tmp$ret$0;
    // Inline function 'kotlin.Long.plus' call
    tmp$ret$0 = max.o6(new Long(1, 0));
    return pct * tmp$ret$0.i6();
  }
  function checkEnabled($this, flag) {
    var tmp;
    if (!flag.h7_1) {
      var tmp_0 = Variant_init_$Create$(flag.j7_1, null, 2, null);
      Companion_getInstance();
      tmp = new EvaluationResult(tmp_0, 'flag-disabled');
    } else {
      tmp = null;
    }
    return tmp;
  }
  function checkEmptyUser($this, flag, user) {
    if (user == null) {
      var variant = getFullyRolledOutVariantIfPresent($this, flag.m7_1.t7_1, flag.k7_1);
      var tmp;
      if (!(variant == null)) {
        Companion_getInstance();
        tmp = new EvaluationResult(variant, 'missing-user-fully-rolled-out-variant');
      } else {
        var tmp_0 = Variant_init_$Create$(flag.j7_1, null, 2, null);
        Companion_getInstance();
        tmp = new EvaluationResult(tmp_0, 'missing-user-default-variant');
      }
      return tmp;
    }
    return null;
  }
  function checkSegments($this, flag, user) {
    var tmp;
    if (!(flag.n7_1 == null)) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp0_isNotEmpty = flag.n7_1;
      tmp$ret$0 = !tmp0_isNotEmpty.k();
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp0_iterator = flag.n7_1.d();
      $l$loop: while (tmp0_iterator.g()) {
        var segment = tmp0_iterator.e();
        var tmp1_elvis_lhs = checkSegment($this, flag, user, segment);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        return tmp_0;
      }
    }
    return checkSegment($this, flag, user, flag.m7_1);
  }
  function checkSegment($this, flag, user, segment) {
    if (!match(segment, user)) {
      return null;
    }
    var bucketingValue = getPropertyValue(user, segment.u7_1);
    var tmp0_elvis_lhs = $this.v7(flag.k7_1, segment.t7_1, flag.i7_1, bucketingValue);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = Variant_init_$Create$(flag.j7_1, null, 2, null);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var variant = tmp;
    return new EvaluationResult(variant, segment.r7_1);
  }
  function checkInclusions($this, flag, user) {
    if (flag.l7_1 == null) {
      return null;
    }
    var tmp0_iterator = flag.k7_1.d();
    $l$loop: while (tmp0_iterator.g()) {
      var variant = tmp0_iterator.e();
      var tmp$ret$0;
      // Inline function 'kotlin.collections.get' call
      var tmp0_get = flag.l7_1;
      var tmp1_get = variant.c7_1;
      tmp$ret$0 = ((!(tmp0_get == null) ? isInterface(tmp0_get, Map) : false) ? tmp0_get : THROW_CCE()).b1(tmp1_get);
      var tmp1_elvis_lhs = tmp$ret$0;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var inclusions = tmp;
      if (contains(inclusions, user.w7_1) ? true : contains(inclusions, user.x7_1)) {
        Companion_getInstance();
        return new EvaluationResult(variant, 'inclusion-list');
      }
    }
    return null;
  }
  function getFullyRolledOutVariantIfPresent($this, allocations, variants) {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = allocations.d();
    while (tmp0_iterator.g()) {
      var element = tmp0_iterator.e();
      var tmp = sum;
      var tmp$ret$0;
      // Inline function 'com.amplitude.experiment.evaluation.EvaluationEngineImpl.getFullyRolledOutVariantIfPresent.<anonymous>' call
      tmp$ret$0 = element.a7_1;
      sum = tmp + tmp$ret$0 | 0;
    }
    tmp$ret$1 = sum;
    var totalAllocationPercentage = tmp$ret$1;
    if (totalAllocationPercentage < 10000) {
      return null;
    }
    if (variants.c() === 1) {
      return variants.f(0);
    }
    var tmp0_elvis_lhs = allocations.f(0).b7_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var weights = tmp_0;
    var fullyRolledOutVariant = null;
    var variantsWithWeights = 0;
    var tmp1_iterator = variants.d();
    while (tmp1_iterator.g()) {
      var variant = tmp1_iterator.e();
      var tmp$ret$2;
      // Inline function 'kotlin.collections.get' call
      var tmp0_get = variant.c7_1;
      tmp$ret$2 = (isInterface(weights, Map) ? weights : THROW_CCE()).b1(tmp0_get);
      var tmp2_elvis_lhs = tmp$ret$2;
      if ((tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) > 0) {
        fullyRolledOutVariant = variant;
        var tmp3 = variantsWithWeights;
        variantsWithWeights = tmp3 + 1 | 0;
      }
    }
    if (variantsWithWeights === 1) {
      return fullyRolledOutVariant;
    }
    return null;
  }
  function EvaluationEngineImpl() {
  }
  EvaluationEngineImpl.prototype.r8 = function (flags, user) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap_init_$Create$();
    var evaluations = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap_init_$Create$();
    var results = tmp$ret$1;
    var tmp0_iterator = flags.d();
    while (tmp0_iterator.g()) {
      var flag = tmp0_iterator.e();
      var evalResult = this.s8(flag, user, evaluations);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = flag.e7_1;
      evaluations.i1(tmp0_set, evalResult);
      var flagResult = FlagResult_init_$Create$(flag, evalResult);
      // Inline function 'kotlin.collections.set' call
      var tmp1_set = flag.e7_1;
      results.i1(tmp1_set, flagResult);
    }
    return results;
  };
  EvaluationEngineImpl.prototype.s8 = function (flag, user, evaluationContext) {
    var tmp0_elvis_lhs = checkEnabled(this, flag);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.t8(flag, evaluationContext) : tmp0_elvis_lhs;
    var result = tmp1_elvis_lhs == null ? checkEmptyUser(this, flag, user) : tmp1_elvis_lhs;
    if (!(result == null)) {
      return result;
    }
    if (user == null) {
      throw RuntimeException_init_$Create$('User should always be non-null at this point.');
    }
    var tmp2_elvis_lhs = checkInclusions(this, flag, user);
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? checkSegments(this, flag, user) : tmp2_elvis_lhs;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      var tmp_0 = Variant_init_$Create$(flag.j7_1, null, 2, null);
      Companion_getInstance();
      tmp = new EvaluationResult(tmp_0, 'default-segment');
    } else {
      tmp = tmp3_elvis_lhs;
    }
    return tmp;
  };
  EvaluationEngineImpl.prototype.t8 = function (flag, results) {
    if (flag.o7_1 == null ? true : flag.o7_1.v8_1.k()) {
      return null;
    }
    if (flag.o7_1.u8_1 === get_PARENT_DEPENDENCY_OPERATOR_ALL()) {
      var tmp0_iterator = flag.o7_1.v8_1.q().d();
      $l$loop: while (tmp0_iterator.g()) {
        var tmp1_loop_parameter = tmp0_iterator.e();
        var tmp$ret$0;
        // Inline function 'kotlin.collections.component1' call
        tmp$ret$0 = tmp1_loop_parameter.r();
        var flagKey = tmp$ret$0;
        var tmp$ret$1;
        // Inline function 'kotlin.collections.component2' call
        tmp$ret$1 = tmp1_loop_parameter.t();
        var allowedVariants = tmp$ret$1;
        if (allowedVariants.k()) {
          continue $l$loop;
        }
        var result = results.b1(flagKey);
        if (result == null ? true : !contains(allowedVariants, result.w8_1.c7_1)) {
          var tmp = Variant_init_$Create$(flag.j7_1, null, 2, null);
          Companion_getInstance();
          return new EvaluationResult(tmp, 'dependency-not-met');
        }
      }
      return null;
    } else if (flag.o7_1.u8_1 === get_PARENT_DEPENDENCY_OPERATOR_ANY()) {
      var tmp2_iterator = flag.o7_1.v8_1.q().d();
      while (tmp2_iterator.g()) {
        var tmp3_loop_parameter = tmp2_iterator.e();
        var tmp$ret$2;
        // Inline function 'kotlin.collections.component1' call
        tmp$ret$2 = tmp3_loop_parameter.r();
        var flagKey_0 = tmp$ret$2;
        var tmp$ret$3;
        // Inline function 'kotlin.collections.component2' call
        tmp$ret$3 = tmp3_loop_parameter.t();
        var allowedVariants_0 = tmp$ret$3;
        if (allowedVariants_0.k()) {
          return null;
        }
        var result_0 = results.b1(flagKey_0);
        if (!(result_0 == null) ? contains(allowedVariants_0, result_0.w8_1.c7_1) : false) {
          return null;
        }
      }
      var tmp_0 = Variant_init_$Create$(flag.j7_1, null, 2, null);
      Companion_getInstance();
      return new EvaluationResult(tmp_0, 'dependency-not-met');
    } else {
      var tmp_1 = Variant_init_$Create$(flag.j7_1, null, 2, null);
      Companion_getInstance();
      return new EvaluationResult(tmp_1, 'invalid-dependency-operator');
    }
  };
  EvaluationEngineImpl.prototype.y8 = function (key) {
    var data = encodeToByteArray(key);
    var value = Murmur3_getInstance().f9(data, data.length, 0);
    return toLong(value).w6(new Long(-1, 0));
  };
  EvaluationEngineImpl.prototype.v7 = function (variants, allocations, bucketingSalt, bucketingValue) {
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    tmp$ret$0 = bucketingValue == null ? true : charSequenceLength(bucketingValue) === 0;
    if (tmp$ret$0) {
      return getFullyRolledOutVariantIfPresent(this, allocations, variants);
    }
    var keyToHash = bucketingSalt + '/' + bucketingValue;
    var hash = this.y8(keyToHash);
    var tmp$ret$1;
    // Inline function 'kotlin.Long.rem' call
    tmp$ret$1 = hash.s6(new Long(100, 0));
    var bucket = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.floorDiv' call
    var tmp$ret$2;
    // Inline function 'kotlin.floorDiv' call
    var tmp0_floorDiv = new Long(100, 0);
    var q = hash.r6(tmp0_floorDiv);
    if (hash.x6(tmp0_floorDiv).n6(new Long(0, 0)) < 0 ? !q.q6(tmp0_floorDiv).equals(hash) : false) {
      var tmp0 = q;
      q = tmp0.t6();
    }
    tmp$ret$2 = q;
    tmp$ret$3 = tmp$ret$2;
    var variantHash = tmp$ret$3;
    var minBucket;
    var maxBucket = new Long(0, 0);
    var tmp0_iterator = allocations.d();
    $l$loop: while (tmp0_iterator.g()) {
      var allocation = tmp0_iterator.e();
      minBucket = maxBucket;
      maxBucket = maxBucket.o6(toLong(allocation.a7_1 / 100 | 0));
      if (minBucket.n6(bucket) <= 0 ? bucket.n6(maxBucket) < 0 : false) {
        var distribution = getVariantDistribution(allocation, variants);
        if (distribution.k()) {
          continue $l$loop;
        }
        var upperBound;
        var tmp1_iterator = distribution.d();
        $l$loop_1: while (tmp1_iterator.g()) {
          var slice = tmp1_iterator.e();
          if (slice.h9_1 <= 0.0) {
            continue $l$loop_1;
          }
          upperBound = scaled(this, slice.i9_1, new Long(42949672, 0));
          if (variantHash.i6() >= upperBound) {
            continue $l$loop_1;
          }
          return slice.g9_1;
        }
      }
    }
    return null;
  };
  function Companion() {
    Companion_instance = this;
    this.j9_1 = 'missing-user-fully-rolled-out-variant';
    this.k9_1 = 'missing-user-default-variant';
    this.l9_1 = 'default-segment';
    this.m9_1 = 'inclusion-list';
    this.n9_1 = 'flag-disabled';
    this.o9_1 = 'dependency-not-met';
    this.p9_1 = 'invalid-dependency-operator';
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function EvaluationResult(variant, description) {
    Companion_getInstance();
    this.w8_1 = variant;
    this.x8_1 = description;
  }
  EvaluationResult.prototype.toString = function () {
    return 'EvaluationResult(variant=' + this.w8_1 + ', description=' + this.x8_1 + ')';
  };
  EvaluationResult.prototype.hashCode = function () {
    var result = this.w8_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.x8_1) | 0;
    return result;
  };
  EvaluationResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EvaluationResult))
      return false;
    var tmp0_other_with_cast = other instanceof EvaluationResult ? other : THROW_CCE();
    if (!this.w8_1.equals(tmp0_other_with_cast.w8_1))
      return false;
    if (!(this.x8_1 === tmp0_other_with_cast.x8_1))
      return false;
    return true;
  };
  function FlagConfig(flagKey, experimentKey, flagVersion, enabled, bucketingSalt, defaultValue, variants, variantsInclusions, allUsersTargetingConfig, customSegmentTargetingConfigs, parentDependencies, type, deployed) {
    this.e7_1 = flagKey;
    this.f7_1 = experimentKey;
    this.g7_1 = flagVersion;
    this.h7_1 = enabled;
    this.i7_1 = bucketingSalt;
    this.j7_1 = defaultValue;
    this.k7_1 = variants;
    this.l7_1 = variantsInclusions;
    this.m7_1 = allUsersTargetingConfig;
    this.n7_1 = customSegmentTargetingConfigs;
    this.o7_1 = parentDependencies;
    this.p7_1 = type;
    this.q7_1 = deployed;
  }
  FlagConfig.prototype.toString = function () {
    return 'FlagConfig(flagKey=' + this.e7_1 + ', experimentKey=' + this.f7_1 + ', flagVersion=' + this.g7_1 + ', enabled=' + this.h7_1 + ', bucketingSalt=' + this.i7_1 + ', defaultValue=' + this.j7_1 + ', variants=' + this.k7_1 + ', variantsInclusions=' + this.l7_1 + ', allUsersTargetingConfig=' + this.m7_1 + ', customSegmentTargetingConfigs=' + this.n7_1 + ', parentDependencies=' + this.o7_1 + ', type=' + this.p7_1 + ', deployed=' + this.q7_1 + ')';
  };
  FlagConfig.prototype.hashCode = function () {
    var result = getStringHashCode(this.e7_1);
    result = imul(result, 31) + (this.f7_1 == null ? 0 : getStringHashCode(this.f7_1)) | 0;
    result = imul(result, 31) + this.g7_1 | 0;
    result = imul(result, 31) + (this.h7_1 | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this.i7_1) | 0;
    result = imul(result, 31) + (this.j7_1 == null ? 0 : getStringHashCode(this.j7_1)) | 0;
    result = imul(result, 31) + hashCode(this.k7_1) | 0;
    result = imul(result, 31) + (this.l7_1 == null ? 0 : hashCode(this.l7_1)) | 0;
    result = imul(result, 31) + this.m7_1.hashCode() | 0;
    result = imul(result, 31) + (this.n7_1 == null ? 0 : hashCode(this.n7_1)) | 0;
    result = imul(result, 31) + (this.o7_1 == null ? 0 : this.o7_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.p7_1) | 0;
    result = imul(result, 31) + (this.q7_1 | 0) | 0;
    return result;
  };
  FlagConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlagConfig))
      return false;
    var tmp0_other_with_cast = other instanceof FlagConfig ? other : THROW_CCE();
    if (!(this.e7_1 === tmp0_other_with_cast.e7_1))
      return false;
    if (!(this.f7_1 == tmp0_other_with_cast.f7_1))
      return false;
    if (!(this.g7_1 === tmp0_other_with_cast.g7_1))
      return false;
    if (!(this.h7_1 === tmp0_other_with_cast.h7_1))
      return false;
    if (!(this.i7_1 === tmp0_other_with_cast.i7_1))
      return false;
    if (!(this.j7_1 == tmp0_other_with_cast.j7_1))
      return false;
    if (!equals(this.k7_1, tmp0_other_with_cast.k7_1))
      return false;
    if (!equals(this.l7_1, tmp0_other_with_cast.l7_1))
      return false;
    if (!this.m7_1.equals(tmp0_other_with_cast.m7_1))
      return false;
    if (!equals(this.n7_1, tmp0_other_with_cast.n7_1))
      return false;
    if (!equals(this.o7_1, tmp0_other_with_cast.o7_1))
      return false;
    if (!(this.p7_1 === tmp0_other_with_cast.p7_1))
      return false;
    if (!(this.q7_1 === tmp0_other_with_cast.q7_1))
      return false;
    return true;
  };
  function get_FLAG_TYPE_RELEASE() {
    return FLAG_TYPE_RELEASE;
  }
  var FLAG_TYPE_RELEASE;
  function FlagResult_init_$Init$(flagConfig, evaluationResult, $this) {
    FlagResult.call($this, evaluationResult.w8_1, evaluationResult.x8_1, flagConfig.j7_1 == evaluationResult.w8_1.c7_1, flagConfig.f7_1, flagConfig.q7_1, flagConfig.p7_1);
    return $this;
  }
  function FlagResult_init_$Create$(flagConfig, evaluationResult) {
    return FlagResult_init_$Init$(flagConfig, evaluationResult, Object.create(FlagResult.prototype));
  }
  function FlagResult(variant, description, isDefaultVariant, expKey, deployed, type) {
    this.q9_1 = variant;
    this.r9_1 = description;
    this.s9_1 = isDefaultVariant;
    this.t9_1 = expKey;
    this.u9_1 = deployed;
    this.v9_1 = type;
  }
  FlagResult.prototype.toString = function () {
    return 'FlagResult(variant=' + this.q9_1 + ', description=' + this.r9_1 + ', isDefaultVariant=' + this.s9_1 + ', expKey=' + this.t9_1 + ', deployed=' + this.u9_1 + ', type=' + this.v9_1 + ')';
  };
  FlagResult.prototype.hashCode = function () {
    var result = this.q9_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.r9_1) | 0;
    result = imul(result, 31) + (this.s9_1 | 0) | 0;
    result = imul(result, 31) + (this.t9_1 == null ? 0 : getStringHashCode(this.t9_1)) | 0;
    result = imul(result, 31) + (this.u9_1 | 0) | 0;
    result = imul(result, 31) + (this.v9_1 == null ? 0 : getStringHashCode(this.v9_1)) | 0;
    return result;
  };
  FlagResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlagResult))
      return false;
    var tmp0_other_with_cast = other instanceof FlagResult ? other : THROW_CCE();
    if (!this.q9_1.equals(tmp0_other_with_cast.q9_1))
      return false;
    if (!(this.r9_1 === tmp0_other_with_cast.r9_1))
      return false;
    if (!(this.s9_1 === tmp0_other_with_cast.s9_1))
      return false;
    if (!(this.t9_1 == tmp0_other_with_cast.t9_1))
      return false;
    if (!(this.u9_1 === tmp0_other_with_cast.u9_1))
      return false;
    if (!(this.v9_1 == tmp0_other_with_cast.v9_1))
      return false;
    return true;
  };
  function Logger() {
    Logger_instance = this;
    this.w9_1 = false;
    this.x9_1 = 'Evaluation';
  }
  Logger.prototype.y9 = function (msg) {
    if (this.w9_1) {
      println('DEBUG [' + this.x9_1 + '] ' + msg);
    }
  };
  Logger.prototype.z9 = function (msg, e) {
    if (e == null) {
      println('ERROR [' + this.x9_1 + '] ' + msg);
    } else {
      println('ERROR [' + this.x9_1 + '] ' + msg + '\n' + e);
    }
  };
  var Logger_instance;
  function Logger_getInstance() {
    if (Logger_instance == null)
      new Logger();
    return Logger_instance;
  }
  function mix32($this, k, hash) {
    var kResult = k;
    var hashResult = hash;
    kResult = imul(kResult, -862048943);
    kResult = rotateLeft(kResult, 15);
    kResult = imul(kResult, 461845907);
    hashResult = hashResult ^ kResult;
    return imul(rotateLeft(hashResult, 13), 5) + -430675100 | 0;
  }
  function fmix32($this, hash) {
    var hashResult = hash;
    hashResult = hashResult ^ (hashResult >>> 16 | 0);
    hashResult = imul(hashResult, -2048144789);
    hashResult = hashResult ^ (hashResult >>> 13 | 0);
    hashResult = imul(hashResult, -1028477387);
    hashResult = hashResult ^ (hashResult >>> 16 | 0);
    return hashResult;
  }
  function Murmur3() {
    Murmur3_instance = this;
    this.z8_1 = -862048943;
    this.a9_1 = 461845907;
    this.b9_1 = 15;
    this.c9_1 = 13;
    this.d9_1 = 5;
    this.e9_1 = -430675100;
  }
  Murmur3.prototype.f9 = function (data, length, seed) {
    var hash = seed;
    var nblocks = length >> 2;
    var inductionVariable = 0;
    if (inductionVariable < nblocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var index = i << 2;
        var k = readIntLe(data, index);
        hash = mix32(this, k, hash);
      }
       while (inductionVariable < nblocks);
    var index_0 = nblocks << 2;
    var k1 = 0;
    var tmp1_subject = length - index_0 | 0;
    switch (tmp1_subject) {
      case 3:
        k1 = k1 ^ (data[index_0 + 2 | 0] & 255) << 16;
        k1 = k1 ^ (data[index_0 + 1 | 0] & 255) << 8;
        k1 = k1 ^ data[index_0] & 255;
        k1 = imul(k1, -862048943);
        k1 = rotateLeft(k1, 15);
        k1 = imul(k1, 461845907);
        hash = hash ^ k1;
        break;
      case 2:
        k1 = k1 ^ (data[index_0 + 1 | 0] & 255) << 8;
        k1 = k1 ^ data[index_0] & 255;
        k1 = imul(k1, -862048943);
        k1 = rotateLeft(k1, 15);
        k1 = imul(k1, 461845907);
        hash = hash ^ k1;
        break;
      case 1:
        k1 = k1 ^ data[index_0] & 255;
        k1 = imul(k1, -862048943);
        k1 = rotateLeft(k1, 15);
        k1 = imul(k1, 461845907);
        hash = hash ^ k1;
        break;
    }
    hash = hash ^ length;
    return fmix32(this, hash);
  };
  var Murmur3_instance;
  function Murmur3_getInstance() {
    if (Murmur3_instance == null)
      new Murmur3();
    return Murmur3_instance;
  }
  function readIntLe(_this__u8e3s4, index) {
    return reverseBytes((_this__u8e3s4[index] & 255) << 24 | (_this__u8e3s4[index + 1 | 0] & 255) << 16 | (_this__u8e3s4[index + 2 | 0] & 255) << 8 | _this__u8e3s4[index + 3 | 0] & 255);
  }
  function reverseBytes(_this__u8e3s4) {
    return (_this__u8e3s4 & -16777216) >>> 24 | 0 | ((_this__u8e3s4 & 16711680) >>> 8 | 0) | (_this__u8e3s4 & 65280) << 8 | (_this__u8e3s4 & 255) << 24;
  }
  var Operator_IS_instance;
  var Operator_IS_NOT_instance;
  var Operator_CONTAINS_instance;
  var Operator_DOES_NOT_CONTAIN_instance;
  var Operator_LESS_THAN_instance;
  var Operator_LESS_THAN_EQUALS_instance;
  var Operator_GREATER_THAN_instance;
  var Operator_GREATER_THAN_EQUALS_instance;
  var Operator_SET_IS_instance;
  var Operator_SET_IS_NOT_instance;
  var Operator_CSS_MATCH_instance;
  var Operator_GLOB_MATCH_instance;
  var Operator_SET_CONTAINS_instance;
  var Operator_SET_DOES_NOT_CONTAIN_instance;
  var Operator_GLOB_DOES_NOT_MATCH_instance;
  var Operator_VERSION_LESS_THAN_instance;
  var Operator_VERSION_LESS_THAN_EQUALS_instance;
  var Operator_VERSION_GREATER_THAN_instance;
  var Operator_VERSION_GREATER_THAN_EQUALS_instance;
  var Operator_HAS_PREFIX_instance;
  var Operator_ENDS_WITH_instance;
  var Operator_entriesInitialized;
  function Operator_initEntries() {
    if (Operator_entriesInitialized)
      return Unit_getInstance();
    Operator_entriesInitialized = true;
    Operator_IS_instance = new Operator('IS', 0, 1);
    Operator_IS_NOT_instance = new Operator('IS_NOT', 1, 2);
    Operator_CONTAINS_instance = new Operator('CONTAINS', 2, 3);
    Operator_DOES_NOT_CONTAIN_instance = new Operator('DOES_NOT_CONTAIN', 3, 4);
    Operator_LESS_THAN_instance = new Operator('LESS_THAN', 4, 5);
    Operator_LESS_THAN_EQUALS_instance = new Operator('LESS_THAN_EQUALS', 5, 6);
    Operator_GREATER_THAN_instance = new Operator('GREATER_THAN', 6, 7);
    Operator_GREATER_THAN_EQUALS_instance = new Operator('GREATER_THAN_EQUALS', 7, 8);
    Operator_SET_IS_instance = new Operator('SET_IS', 8, 9);
    Operator_SET_IS_NOT_instance = new Operator('SET_IS_NOT', 9, 10);
    Operator_CSS_MATCH_instance = new Operator('CSS_MATCH', 10, 11);
    Operator_GLOB_MATCH_instance = new Operator('GLOB_MATCH', 11, 12);
    Operator_SET_CONTAINS_instance = new Operator('SET_CONTAINS', 12, 13);
    Operator_SET_DOES_NOT_CONTAIN_instance = new Operator('SET_DOES_NOT_CONTAIN', 13, 14);
    Operator_GLOB_DOES_NOT_MATCH_instance = new Operator('GLOB_DOES_NOT_MATCH', 14, 15);
    Operator_VERSION_LESS_THAN_instance = new Operator('VERSION_LESS_THAN', 15, 16);
    Operator_VERSION_LESS_THAN_EQUALS_instance = new Operator('VERSION_LESS_THAN_EQUALS', 16, 17);
    Operator_VERSION_GREATER_THAN_instance = new Operator('VERSION_GREATER_THAN', 17, 18);
    Operator_VERSION_GREATER_THAN_EQUALS_instance = new Operator('VERSION_GREATER_THAN_EQUALS', 18, 19);
    Operator_HAS_PREFIX_instance = new Operator('HAS_PREFIX', 19, 20);
    Operator_ENDS_WITH_instance = new Operator('ENDS_WITH', 20, 21);
  }
  function Operator(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.ca_1 = value;
  }
  function Operator_IS_getInstance() {
    Operator_initEntries();
    return Operator_IS_instance;
  }
  function Operator_IS_NOT_getInstance() {
    Operator_initEntries();
    return Operator_IS_NOT_instance;
  }
  function Operator_CONTAINS_getInstance() {
    Operator_initEntries();
    return Operator_CONTAINS_instance;
  }
  function Operator_DOES_NOT_CONTAIN_getInstance() {
    Operator_initEntries();
    return Operator_DOES_NOT_CONTAIN_instance;
  }
  function Operator_LESS_THAN_getInstance() {
    Operator_initEntries();
    return Operator_LESS_THAN_instance;
  }
  function Operator_LESS_THAN_EQUALS_getInstance() {
    Operator_initEntries();
    return Operator_LESS_THAN_EQUALS_instance;
  }
  function Operator_GREATER_THAN_getInstance() {
    Operator_initEntries();
    return Operator_GREATER_THAN_instance;
  }
  function Operator_GREATER_THAN_EQUALS_getInstance() {
    Operator_initEntries();
    return Operator_GREATER_THAN_EQUALS_instance;
  }
  function Operator_SET_IS_getInstance() {
    Operator_initEntries();
    return Operator_SET_IS_instance;
  }
  function Operator_SET_IS_NOT_getInstance() {
    Operator_initEntries();
    return Operator_SET_IS_NOT_instance;
  }
  function Operator_CSS_MATCH_getInstance() {
    Operator_initEntries();
    return Operator_CSS_MATCH_instance;
  }
  function Operator_GLOB_MATCH_getInstance() {
    Operator_initEntries();
    return Operator_GLOB_MATCH_instance;
  }
  function Operator_SET_CONTAINS_getInstance() {
    Operator_initEntries();
    return Operator_SET_CONTAINS_instance;
  }
  function Operator_SET_DOES_NOT_CONTAIN_getInstance() {
    Operator_initEntries();
    return Operator_SET_DOES_NOT_CONTAIN_instance;
  }
  function Operator_GLOB_DOES_NOT_MATCH_getInstance() {
    Operator_initEntries();
    return Operator_GLOB_DOES_NOT_MATCH_instance;
  }
  function Operator_VERSION_LESS_THAN_getInstance() {
    Operator_initEntries();
    return Operator_VERSION_LESS_THAN_instance;
  }
  function Operator_VERSION_LESS_THAN_EQUALS_getInstance() {
    Operator_initEntries();
    return Operator_VERSION_LESS_THAN_EQUALS_instance;
  }
  function Operator_VERSION_GREATER_THAN_getInstance() {
    Operator_initEntries();
    return Operator_VERSION_GREATER_THAN_instance;
  }
  function Operator_VERSION_GREATER_THAN_EQUALS_getInstance() {
    Operator_initEntries();
    return Operator_VERSION_GREATER_THAN_EQUALS_instance;
  }
  function Operator_HAS_PREFIX_getInstance() {
    Operator_initEntries();
    return Operator_HAS_PREFIX_instance;
  }
  function Operator_ENDS_WITH_getInstance() {
    Operator_initEntries();
    return Operator_ENDS_WITH_instance;
  }
  function ParentDependencies(operator, flags) {
    this.u8_1 = operator;
    this.v8_1 = flags;
  }
  ParentDependencies.prototype.toString = function () {
    return 'ParentDependencies(operator=' + this.u8_1 + ', flags=' + this.v8_1 + ')';
  };
  ParentDependencies.prototype.hashCode = function () {
    var result = getStringHashCode(this.u8_1);
    result = imul(result, 31) + hashCode(this.v8_1) | 0;
    return result;
  };
  ParentDependencies.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ParentDependencies))
      return false;
    var tmp0_other_with_cast = other instanceof ParentDependencies ? other : THROW_CCE();
    if (!(this.u8_1 === tmp0_other_with_cast.u8_1))
      return false;
    if (!equals(this.v8_1, tmp0_other_with_cast.v8_1))
      return false;
    return true;
  };
  function get_PARENT_DEPENDENCY_OPERATOR_ALL() {
    return PARENT_DEPENDENCY_OPERATOR_ALL;
  }
  var PARENT_DEPENDENCY_OPERATOR_ALL;
  function get_PARENT_DEPENDENCY_OPERATOR_ANY() {
    return PARENT_DEPENDENCY_OPERATOR_ANY;
  }
  var PARENT_DEPENDENCY_OPERATOR_ANY;
  function get_VERSION_USER_PROPS() {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    return VERSION_USER_PROPS;
  }
  var VERSION_USER_PROPS;
  function get_VERSION_OPERATOR_MAP() {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    return VERSION_OPERATOR_MAP;
  }
  var VERSION_OPERATOR_MAP;
  function SegmentTargetingConfig(name, conditions, allocations, bucketingKey) {
    this.r7_1 = name;
    this.s7_1 = conditions;
    this.t7_1 = allocations;
    this.u7_1 = bucketingKey;
  }
  SegmentTargetingConfig.prototype.toString = function () {
    return 'SegmentTargetingConfig(name=' + this.r7_1 + ', conditions=' + this.s7_1 + ', allocations=' + this.t7_1 + ', bucketingKey=' + this.u7_1 + ')';
  };
  SegmentTargetingConfig.prototype.hashCode = function () {
    var result = getStringHashCode(this.r7_1);
    result = imul(result, 31) + hashCode(this.s7_1) | 0;
    result = imul(result, 31) + hashCode(this.t7_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u7_1) | 0;
    return result;
  };
  SegmentTargetingConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SegmentTargetingConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SegmentTargetingConfig ? other : THROW_CCE();
    if (!(this.r7_1 === tmp0_other_with_cast.r7_1))
      return false;
    if (!equals(this.s7_1, tmp0_other_with_cast.s7_1))
      return false;
    if (!equals(this.t7_1, tmp0_other_with_cast.t7_1))
      return false;
    if (!(this.u7_1 === tmp0_other_with_cast.u7_1))
      return false;
    return true;
  };
  function match(_this__u8e3s4, user) {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    return match_0(_this__u8e3s4.s7_1, user);
  }
  function match_0(_this__u8e3s4, user) {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    if (user == null) {
      return false;
    }
    Logger_getInstance().y9('User: ' + user + ' to be matched against filters for segment: ' + _this__u8e3s4);
    var tmp0_iterator = _this__u8e3s4.d();
    while (tmp0_iterator.g()) {
      var filter = tmp0_iterator.e();
      if (isCohortFilter(filter)) {
        var userMatchesCohortFilter = matchesCohortUserPropFilter(user, filter);
        Logger_getInstance().y9('User: ' + user + ' returned: ' + userMatchesCohortFilter + ' for cohort match for filter: ' + filter);
        if (!userMatchesCohortFilter) {
          return false;
        }
      } else {
        var tmp;
        if (get_VERSION_USER_PROPS().h(filter.da_1)) {
          tmp = toVersionOperator(filter.ea_1);
        } else {
          tmp = filter.ea_1;
        }
        var op = tmp;
        var matchFilter = new StringMatchColumnFilter(filter.da_1, op, filter.fa_1);
        var userPropValue = getPropertyValue(user, filter.da_1);
        var tmp_0;
        if (userPropValue == null) {
          tmp_0 = matchesNull(matchFilter);
        } else {
          var tmp_1;
          try {
            tmp_1 = matches(matchFilter, userPropValue);
          } catch ($p) {
            var tmp_2;
            if ($p instanceof IllegalArgumentException) {
              Logger_getInstance().z9('failed to match filter ' + matchFilter, $p);
              tmp_2 = false;
            } else {
              throw $p;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        }
        var matchesFilter = tmp_0;
        if (!matchesFilter) {
          return false;
        }
      }
    }
    Logger_getInstance().y9('User: ' + user + ' matches all filters for segment: ' + _this__u8e3s4);
    return true;
  }
  function matchesCohortUserPropFilter(_this__u8e3s4, userFilter) {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    var tmp0_subject = userFilter.ea_1;
    var tmp0 = tmp0_subject.a6_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = belongsToCohort(_this__u8e3s4, userFilter.fa_1);
        break;
      case 1:
        tmp = !belongsToCohort(_this__u8e3s4, userFilter.fa_1);
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Not supported for cohorts');
    }
    return tmp;
  }
  function toVersionOperator(_this__u8e3s4) {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    var tmp0_elvis_lhs = get_VERSION_OPERATOR_MAP().b1(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  }
  function belongsToCohort(_this__u8e3s4, filterCohortIds) {
    init_properties_SegmentTargetingConfig_kt_inm18a();
    if (filterCohortIds.k()) {
      return true;
    }
    var tmp;
    if (_this__u8e3s4 == null) {
      tmp = true;
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var tmp0_isNullOrEmpty = _this__u8e3s4.p8_1;
      // Inline function 'kotlin.contracts.contract' call
      tmp$ret$0 = tmp0_isNullOrEmpty == null ? true : tmp0_isNullOrEmpty.k();
      tmp = tmp$ret$0;
    }
    if (tmp) {
      return false;
    }
    var tmp0_iterator = filterCohortIds.d();
    while (tmp0_iterator.g()) {
      var cohortId = tmp0_iterator.e();
      if (_this__u8e3s4.p8_1.h(cohortId)) {
        return true;
      }
    }
    return false;
  }
  var properties_initialized_SegmentTargetingConfig_kt_ld7wgy;
  function init_properties_SegmentTargetingConfig_kt_inm18a() {
    if (properties_initialized_SegmentTargetingConfig_kt_ld7wgy) {
    } else {
      properties_initialized_SegmentTargetingConfig_kt_ld7wgy = true;
      VERSION_USER_PROPS = hashSetOf(['version', 'start_version']);
      VERSION_OPERATOR_MAP = mapOf([to(Operator_LESS_THAN_getInstance(), Operator_VERSION_LESS_THAN_getInstance()), to(Operator_LESS_THAN_EQUALS_getInstance(), Operator_VERSION_LESS_THAN_EQUALS_getInstance()), to(Operator_GREATER_THAN_getInstance(), Operator_VERSION_GREATER_THAN_getInstance()), to(Operator_GREATER_THAN_EQUALS_getInstance(), Operator_VERSION_GREATER_THAN_EQUALS_getInstance())]);
    }
  }
  function SkylabUser_init_$Init$(userId, deviceId, amplitudeId, country, region, dma, city, language, platform, version, startVersion, os, deviceManufacturer, deviceBrand, deviceModel, deviceFamily, deviceType, carrier, library, cohortIds, userProperties, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      userId = null;
    if (!(($mask0 & 2) === 0))
      deviceId = null;
    if (!(($mask0 & 4) === 0))
      amplitudeId = new Long(0, 0);
    if (!(($mask0 & 8) === 0))
      country = null;
    if (!(($mask0 & 16) === 0))
      region = null;
    if (!(($mask0 & 32) === 0))
      dma = null;
    if (!(($mask0 & 64) === 0))
      city = null;
    if (!(($mask0 & 128) === 0))
      language = null;
    if (!(($mask0 & 256) === 0))
      platform = null;
    if (!(($mask0 & 512) === 0))
      version = null;
    if (!(($mask0 & 1024) === 0))
      startVersion = null;
    if (!(($mask0 & 2048) === 0))
      os = null;
    if (!(($mask0 & 4096) === 0))
      deviceManufacturer = null;
    if (!(($mask0 & 8192) === 0))
      deviceBrand = null;
    if (!(($mask0 & 16384) === 0))
      deviceModel = null;
    if (!(($mask0 & 32768) === 0))
      deviceFamily = null;
    if (!(($mask0 & 65536) === 0))
      deviceType = null;
    if (!(($mask0 & 131072) === 0))
      carrier = null;
    if (!(($mask0 & 262144) === 0))
      library = null;
    if (!(($mask0 & 524288) === 0))
      cohortIds = null;
    if (!(($mask0 & 1048576) === 0))
      userProperties = null;
    SkylabUser.call($this, userId, deviceId, amplitudeId, country, region, dma, city, language, platform, version, startVersion, os, deviceManufacturer, deviceBrand, deviceModel, deviceFamily, deviceType, carrier, library, cohortIds, userProperties);
    return $this;
  }
  function SkylabUser_init_$Create$(userId, deviceId, amplitudeId, country, region, dma, city, language, platform, version, startVersion, os, deviceManufacturer, deviceBrand, deviceModel, deviceFamily, deviceType, carrier, library, cohortIds, userProperties, $mask0, $marker) {
    return SkylabUser_init_$Init$(userId, deviceId, amplitudeId, country, region, dma, city, language, platform, version, startVersion, os, deviceManufacturer, deviceBrand, deviceModel, deviceFamily, deviceType, carrier, library, cohortIds, userProperties, $mask0, $marker, Object.create(SkylabUser.prototype));
  }
  function Keys() {
    Keys_instance = this;
    this.ga_1 = 'user_id';
    this.ha_1 = 'device_id';
    this.ia_1 = 'amplitude_id';
    this.ja_1 = 'device_family';
    this.ka_1 = 'device_type';
    this.la_1 = 'device_manufacturer';
    this.ma_1 = 'device_brand';
    this.na_1 = 'device_model';
    this.oa_1 = 'country';
    this.pa_1 = 'region';
    this.qa_1 = 'dma';
    this.ra_1 = 'city';
    this.sa_1 = 'language';
    this.ta_1 = 'platform';
    this.ua_1 = 'version';
    this.va_1 = 'start_version';
    this.wa_1 = 'os';
    this.xa_1 = 'carrier';
    this.ya_1 = 'library';
    this.za_1 = 'user_properties';
    this.ab_1 = 'cohort_ids';
  }
  var Keys_instance;
  function Keys_getInstance() {
    if (Keys_instance == null)
      new Keys();
    return Keys_instance;
  }
  function SkylabUser(userId, deviceId, amplitudeId, country, region, dma, city, language, platform, version, startVersion, os, deviceManufacturer, deviceBrand, deviceModel, deviceFamily, deviceType, carrier, library, cohortIds, userProperties) {
    Keys_getInstance();
    this.w7_1 = userId;
    this.x7_1 = deviceId;
    this.y7_1 = amplitudeId;
    this.z7_1 = country;
    this.a8_1 = region;
    this.b8_1 = dma;
    this.c8_1 = city;
    this.d8_1 = language;
    this.e8_1 = platform;
    this.f8_1 = version;
    this.g8_1 = startVersion;
    this.h8_1 = os;
    this.i8_1 = deviceManufacturer;
    this.j8_1 = deviceBrand;
    this.k8_1 = deviceModel;
    this.l8_1 = deviceFamily;
    this.m8_1 = deviceType;
    this.n8_1 = carrier;
    this.o8_1 = library;
    this.p8_1 = cohortIds;
    this.q8_1 = userProperties;
  }
  SkylabUser.prototype.toString = function () {
    return 'SkylabUser(userId=' + this.w7_1 + ', deviceId=' + this.x7_1 + ', amplitudeId=' + toString(this.y7_1) + ', country=' + this.z7_1 + ', region=' + this.a8_1 + ', dma=' + this.b8_1 + ', city=' + this.c8_1 + ', language=' + this.d8_1 + ', platform=' + this.e8_1 + ', version=' + this.f8_1 + ', startVersion=' + this.g8_1 + ', os=' + this.h8_1 + ', deviceManufacturer=' + this.i8_1 + ', deviceBrand=' + this.j8_1 + ', deviceModel=' + this.k8_1 + ', deviceFamily=' + this.l8_1 + ', deviceType=' + this.m8_1 + ', carrier=' + this.n8_1 + ', library=' + this.o8_1 + ', cohortIds=' + this.p8_1 + ', userProperties=' + this.q8_1 + ')';
  };
  SkylabUser.prototype.hashCode = function () {
    var result = this.w7_1 == null ? 0 : getStringHashCode(this.w7_1);
    result = imul(result, 31) + (this.x7_1 == null ? 0 : getStringHashCode(this.x7_1)) | 0;
    result = imul(result, 31) + (this.y7_1 == null ? 0 : this.y7_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z7_1 == null ? 0 : getStringHashCode(this.z7_1)) | 0;
    result = imul(result, 31) + (this.a8_1 == null ? 0 : getStringHashCode(this.a8_1)) | 0;
    result = imul(result, 31) + (this.b8_1 == null ? 0 : getStringHashCode(this.b8_1)) | 0;
    result = imul(result, 31) + (this.c8_1 == null ? 0 : getStringHashCode(this.c8_1)) | 0;
    result = imul(result, 31) + (this.d8_1 == null ? 0 : getStringHashCode(this.d8_1)) | 0;
    result = imul(result, 31) + (this.e8_1 == null ? 0 : getStringHashCode(this.e8_1)) | 0;
    result = imul(result, 31) + (this.f8_1 == null ? 0 : getStringHashCode(this.f8_1)) | 0;
    result = imul(result, 31) + (this.g8_1 == null ? 0 : getStringHashCode(this.g8_1)) | 0;
    result = imul(result, 31) + (this.h8_1 == null ? 0 : getStringHashCode(this.h8_1)) | 0;
    result = imul(result, 31) + (this.i8_1 == null ? 0 : getStringHashCode(this.i8_1)) | 0;
    result = imul(result, 31) + (this.j8_1 == null ? 0 : getStringHashCode(this.j8_1)) | 0;
    result = imul(result, 31) + (this.k8_1 == null ? 0 : getStringHashCode(this.k8_1)) | 0;
    result = imul(result, 31) + (this.l8_1 == null ? 0 : getStringHashCode(this.l8_1)) | 0;
    result = imul(result, 31) + (this.m8_1 == null ? 0 : getStringHashCode(this.m8_1)) | 0;
    result = imul(result, 31) + (this.n8_1 == null ? 0 : getStringHashCode(this.n8_1)) | 0;
    result = imul(result, 31) + (this.o8_1 == null ? 0 : getStringHashCode(this.o8_1)) | 0;
    result = imul(result, 31) + (this.p8_1 == null ? 0 : hashCode(this.p8_1)) | 0;
    result = imul(result, 31) + (this.q8_1 == null ? 0 : hashCode(this.q8_1)) | 0;
    return result;
  };
  SkylabUser.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SkylabUser))
      return false;
    var tmp0_other_with_cast = other instanceof SkylabUser ? other : THROW_CCE();
    if (!(this.w7_1 == tmp0_other_with_cast.w7_1))
      return false;
    if (!(this.x7_1 == tmp0_other_with_cast.x7_1))
      return false;
    if (!equals(this.y7_1, tmp0_other_with_cast.y7_1))
      return false;
    if (!(this.z7_1 == tmp0_other_with_cast.z7_1))
      return false;
    if (!(this.a8_1 == tmp0_other_with_cast.a8_1))
      return false;
    if (!(this.b8_1 == tmp0_other_with_cast.b8_1))
      return false;
    if (!(this.c8_1 == tmp0_other_with_cast.c8_1))
      return false;
    if (!(this.d8_1 == tmp0_other_with_cast.d8_1))
      return false;
    if (!(this.e8_1 == tmp0_other_with_cast.e8_1))
      return false;
    if (!(this.f8_1 == tmp0_other_with_cast.f8_1))
      return false;
    if (!(this.g8_1 == tmp0_other_with_cast.g8_1))
      return false;
    if (!(this.h8_1 == tmp0_other_with_cast.h8_1))
      return false;
    if (!(this.i8_1 == tmp0_other_with_cast.i8_1))
      return false;
    if (!(this.j8_1 == tmp0_other_with_cast.j8_1))
      return false;
    if (!(this.k8_1 == tmp0_other_with_cast.k8_1))
      return false;
    if (!(this.l8_1 == tmp0_other_with_cast.l8_1))
      return false;
    if (!(this.m8_1 == tmp0_other_with_cast.m8_1))
      return false;
    if (!(this.n8_1 == tmp0_other_with_cast.n8_1))
      return false;
    if (!(this.o8_1 == tmp0_other_with_cast.o8_1))
      return false;
    if (!equals(this.p8_1, tmp0_other_with_cast.p8_1))
      return false;
    if (!equals(this.q8_1, tmp0_other_with_cast.q8_1))
      return false;
    return true;
  };
  function getPropertyValue(_this__u8e3s4, key) {
    if (isCustomUserProperty(key)) {
      var sanitizedKey = sanitizeCustomUserPropKey(key);
      var tmp;
      var tmp_0;
      if (_this__u8e3s4.q8_1 == null) {
        tmp_0 = true;
      } else {
        var tmp$ret$0;
        // Inline function 'kotlin.collections.containsKey' call
        var tmp0_containsKey = _this__u8e3s4.q8_1;
        tmp$ret$0 = ((!(tmp0_containsKey == null) ? isInterface(tmp0_containsKey, Map) : false) ? tmp0_containsKey : THROW_CCE()).z(sanitizedKey);
        tmp_0 = !tmp$ret$0;
      }
      if (tmp_0) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.collections.get' call
        var tmp1_get = _this__u8e3s4.q8_1;
        tmp$ret$1 = ((!(tmp1_get == null) ? isInterface(tmp1_get, Map) : false) ? tmp1_get : THROW_CCE()).b1(sanitizedKey);
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toString_0(tmp0_safe_receiver);
        tmp = tmp1_safe_receiver == null ? null : removeSurrounding(tmp1_safe_receiver, '"');
      }
      return tmp;
    }
    var tmp2_subject = key;
    var tmp_1;
    Keys_getInstance();
    if (tmp2_subject === 'amplitude_id') {
      tmp_1 = toString(_this__u8e3s4.y7_1);
    } else {
      Keys_getInstance();
      if (tmp2_subject === 'user_id') {
        tmp_1 = _this__u8e3s4.w7_1;
      } else {
        Keys_getInstance();
        if (tmp2_subject === 'device_id') {
          tmp_1 = _this__u8e3s4.x7_1;
        } else {
          Keys_getInstance();
          if (tmp2_subject === 'country') {
            tmp_1 = _this__u8e3s4.z7_1;
          } else {
            Keys_getInstance();
            if (tmp2_subject === 'region') {
              tmp_1 = _this__u8e3s4.a8_1;
            } else {
              Keys_getInstance();
              if (tmp2_subject === 'dma') {
                tmp_1 = _this__u8e3s4.b8_1;
              } else {
                Keys_getInstance();
                if (tmp2_subject === 'city') {
                  tmp_1 = _this__u8e3s4.c8_1;
                } else {
                  Keys_getInstance();
                  if (tmp2_subject === 'language') {
                    tmp_1 = _this__u8e3s4.d8_1;
                  } else {
                    Keys_getInstance();
                    if (tmp2_subject === 'platform') {
                      tmp_1 = _this__u8e3s4.e8_1;
                    } else {
                      Keys_getInstance();
                      if (tmp2_subject === 'version') {
                        tmp_1 = _this__u8e3s4.f8_1;
                      } else {
                        Keys_getInstance();
                        if (tmp2_subject === 'start_version') {
                          tmp_1 = _this__u8e3s4.g8_1;
                        } else {
                          Keys_getInstance();
                          if (tmp2_subject === 'os') {
                            tmp_1 = _this__u8e3s4.h8_1;
                          } else {
                            Keys_getInstance();
                            if (tmp2_subject === 'device_family') {
                              tmp_1 = _this__u8e3s4.l8_1;
                            } else {
                              Keys_getInstance();
                              if (tmp2_subject === 'device_type') {
                                tmp_1 = _this__u8e3s4.m8_1;
                              } else {
                                Keys_getInstance();
                                if (tmp2_subject === 'device_brand') {
                                  tmp_1 = _this__u8e3s4.j8_1;
                                } else {
                                  Keys_getInstance();
                                  if (tmp2_subject === 'device_manufacturer') {
                                    tmp_1 = _this__u8e3s4.i8_1;
                                  } else {
                                    Keys_getInstance();
                                    if (tmp2_subject === 'device_model') {
                                      tmp_1 = _this__u8e3s4.k8_1;
                                    } else {
                                      Keys_getInstance();
                                      if (tmp2_subject === 'carrier') {
                                        tmp_1 = _this__u8e3s4.n8_1;
                                      } else {
                                        Keys_getInstance();
                                        if (tmp2_subject === 'library') {
                                          tmp_1 = _this__u8e3s4.o8_1;
                                        } else {
                                          Logger_getInstance().y9('Property key ' + key + ' not found on SkylabUser');
                                          tmp_1 = null;
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp_1;
  }
  function isCustomUserProperty(_this__u8e3s4) {
    return startsWith$default(_this__u8e3s4, 'gp:', false, 2, null);
  }
  function sanitizeCustomUserPropKey(_this__u8e3s4) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = _this__u8e3s4;
    tmp$ret$1 = tmp$ret$0.substring(3);
    return tmp$ret$1;
  }
  function StringMatchColumnFilter(columnName, operator, values) {
    this.bb_1 = columnName;
    this.cb_1 = operator;
    this.db_1 = values;
    this.eb_1 = containsNone(this.db_1);
    this.fb_1 = containsBooleans(this.db_1);
  }
  StringMatchColumnFilter.prototype.toString = function () {
    return 'StringMatchColumnFilter(columnName=' + this.bb_1 + ', operator=' + this.cb_1 + ', values=' + this.db_1 + ')';
  };
  StringMatchColumnFilter.prototype.hashCode = function () {
    var result = getStringHashCode(this.bb_1);
    result = imul(result, 31) + this.cb_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.db_1) | 0;
    return result;
  };
  StringMatchColumnFilter.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringMatchColumnFilter))
      return false;
    var tmp0_other_with_cast = other instanceof StringMatchColumnFilter ? other : THROW_CCE();
    if (!(this.bb_1 === tmp0_other_with_cast.bb_1))
      return false;
    if (!this.cb_1.equals(tmp0_other_with_cast.cb_1))
      return false;
    if (!equals(this.db_1, tmp0_other_with_cast.db_1))
      return false;
    return true;
  };
  function matchesNull(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.cb_1;
    var tmp0 = tmp0_subject.a6_1;
    var tmp;
    switch (tmp0) {
      case 0:
      case 2:
      case 4:
      case 5:
      case 6:
      case 7:
      case 15:
      case 16:
      case 17:
      case 18:
      case 8:
      case 12:
        tmp = _this__u8e3s4.eb_1;
        break;
      case 1:
      case 3:
        tmp = !_this__u8e3s4.eb_1;
        break;
      case 9:
      case 13:
      case 14:
        tmp = true;
        break;
      case 10:
      case 11:
        tmp = false;
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unexpected operator ' + _this__u8e3s4.cb_1);
    }
    return tmp;
  }
  function matches(_this__u8e3s4, value) {
    var tmp0_subject = _this__u8e3s4.cb_1;
    var tmp0 = tmp0_subject.a6_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = matchesIs(value, _this__u8e3s4.db_1, _this__u8e3s4.fb_1);
        break;
      case 1:
        tmp = !matchesIs(value, _this__u8e3s4.db_1, _this__u8e3s4.fb_1);
        break;
      case 2:
        tmp = matchesContains(value, _this__u8e3s4.db_1);
        break;
      case 3:
        tmp = !matchesContains(value, _this__u8e3s4.db_1);
        break;
      case 4:
      case 5:
      case 6:
      case 7:
        tmp = matchesCompare(value, _this__u8e3s4.db_1, _this__u8e3s4.cb_1);
        break;
      case 19:
        tmp = matchesHasPrefix(value, _this__u8e3s4.db_1);
        break;
      case 20:
        tmp = matchesEndsWith(value, _this__u8e3s4.db_1);
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unexpected or unsupported operator ' + _this__u8e3s4.cb_1);
    }
    return tmp;
  }
  function containsNone(_this__u8e3s4) {
    return _this__u8e3s4.h('(none)');
  }
  function containsBooleans(_this__u8e3s4) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.k();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.d();
      while (tmp0_iterator.g()) {
        var element = tmp0_iterator.e();
        var tmp$ret$1;
        // Inline function 'com.amplitude.experiment.evaluation.containsBooleans.<anonymous>' call
        tmp$ret$1 = element === 'true' ? true : element === 'false';
        if (tmp$ret$1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function matchesIs(_this__u8e3s4, values, hasBooleans) {
    var value = _this__u8e3s4;
    if (hasBooleans) {
      var tmp0_safe_receiver = _this__u8e3s4;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.text.lowercase' call
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp0_safe_receiver;
        tmp$ret$1 = tmp$ret$0.toLowerCase();
        tmp = tmp$ret$1;
      }
      var lower = tmp;
      if (lower === 'true' ? true : lower === 'false') {
        value = lower;
      }
    }
    return values.h(value);
  }
  function matchesContains(_this__u8e3s4, values) {
    if (_this__u8e3s4 == null) {
      return false;
    }
    var tmp0_iterator = values.d();
    $l$loop: while (tmp0_iterator.g()) {
      var filterValue = tmp0_iterator.e();
      var tmp1_elvis_lhs = filterValue;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var filter = tmp;
      if (contains_0(_this__u8e3s4, filter, true)) {
        return true;
      }
    }
    return false;
  }
  function matchesCompare(_this__u8e3s4, values, operator) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(values, Collection)) {
        tmp = values.k();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = values.d();
      while (tmp0_iterator.g()) {
        var element = tmp0_iterator.e();
        var tmp$ret$1;
        // Inline function 'com.amplitude.experiment.evaluation.matchesCompare.<anonymous>' call
        tmp$ret$1 = compareStrings(_this__u8e3s4, operator, element);
        if (tmp$ret$1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function matchesHasPrefix(_this__u8e3s4, values) {
    if (_this__u8e3s4 == null) {
      return false;
    }
    var tmp0_iterator = values.d();
    $l$loop: while (tmp0_iterator.g()) {
      var filterValue = tmp0_iterator.e();
      var tmp1_elvis_lhs = filterValue;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var filter = tmp;
      if (startsWith$default(_this__u8e3s4, filter, false, 2, null)) {
        return true;
      }
    }
    return false;
  }
  function matchesEndsWith(_this__u8e3s4, values) {
    if (_this__u8e3s4 == null) {
      return false;
    }
    var tmp0_iterator = values.d();
    $l$loop: while (tmp0_iterator.g()) {
      var filterValue = tmp0_iterator.e();
      var tmp1_elvis_lhs = filterValue;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var filter = tmp;
      if (endsWith$default(_this__u8e3s4, filter, false, 2, null)) {
        return true;
      }
    }
    return false;
  }
  function compareStrings(_this__u8e3s4, operator, filterValue) {
    if (_this__u8e3s4 == null ? true : filterValue == null) {
      return false;
    }
    var compareTo_0 = compareTo(_this__u8e3s4, filterValue);
    var tmp0_subject = operator;
    var tmp0 = tmp0_subject.a6_1;
    var tmp;
    switch (tmp0) {
      case 4:
        tmp = compareTo_0 < 0;
        break;
      case 5:
        tmp = compareTo_0 <= 0;
        break;
      case 6:
        tmp = compareTo_0 > 0;
        break;
      case 7:
        tmp = compareTo_0 >= 0;
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unexpected operator ' + operator);
    }
    return tmp;
  }
  function UserPropertyFilter(prop, op, values) {
    this.da_1 = prop;
    this.ea_1 = op;
    this.fa_1 = values;
  }
  UserPropertyFilter.prototype.toString = function () {
    return 'UserPropertyFilter(prop=' + this.da_1 + ', op=' + this.ea_1 + ', values=' + this.fa_1 + ')';
  };
  UserPropertyFilter.prototype.hashCode = function () {
    var result = getStringHashCode(this.da_1);
    result = imul(result, 31) + this.ea_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.fa_1) | 0;
    return result;
  };
  UserPropertyFilter.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserPropertyFilter))
      return false;
    var tmp0_other_with_cast = other instanceof UserPropertyFilter ? other : THROW_CCE();
    if (!(this.da_1 === tmp0_other_with_cast.da_1))
      return false;
    if (!this.ea_1.equals(tmp0_other_with_cast.ea_1))
      return false;
    if (!equals(this.fa_1, tmp0_other_with_cast.fa_1))
      return false;
    return true;
  };
  function isCohortFilter(_this__u8e3s4) {
    return _this__u8e3s4.da_1 === 'userdata_cohort';
  }
  function Variant_init_$Init$(key, payload, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      key = null;
    if (!(($mask0 & 2) === 0))
      payload = null;
    Variant.call($this, key, payload);
    return $this;
  }
  function Variant_init_$Create$(key, payload, $mask0, $marker) {
    return Variant_init_$Init$(key, payload, $mask0, $marker, Object.create(Variant.prototype));
  }
  function Variant(key, payload) {
    this.c7_1 = key;
    this.d7_1 = payload;
  }
  Variant.prototype.toString = function () {
    return 'Variant(key=' + this.c7_1 + ', payload=' + toString(this.d7_1) + ')';
  };
  Variant.prototype.hashCode = function () {
    var result = this.c7_1 == null ? 0 : getStringHashCode(this.c7_1);
    result = imul(result, 31) + (this.d7_1 == null ? 0 : hashCode(this.d7_1)) | 0;
    return result;
  };
  Variant.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Variant))
      return false;
    var tmp0_other_with_cast = other instanceof Variant ? other : THROW_CCE();
    if (!(this.c7_1 == tmp0_other_with_cast.c7_1))
      return false;
    if (!equals(this.d7_1, tmp0_other_with_cast.d7_1))
      return false;
    return true;
  };
  function VariantDistribution(variant, pct, cumulativePct) {
    this.g9_1 = variant;
    this.h9_1 = pct;
    this.i9_1 = cumulativePct;
  }
  VariantDistribution.prototype.toString = function () {
    return 'VariantDistribution(variant=' + this.g9_1 + ', pct=' + this.h9_1 + ', cumulativePct=' + this.i9_1 + ')';
  };
  VariantDistribution.prototype.hashCode = function () {
    var result = this.g9_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.h9_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i9_1) | 0;
    return result;
  };
  VariantDistribution.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VariantDistribution))
      return false;
    var tmp0_other_with_cast = other instanceof VariantDistribution ? other : THROW_CCE();
    if (!this.g9_1.equals(tmp0_other_with_cast.g9_1))
      return false;
    if (!equals(this.h9_1, tmp0_other_with_cast.h9_1))
      return false;
    if (!equals(this.i9_1, tmp0_other_with_cast.i9_1))
      return false;
    return true;
  };
  //region block: init
  FLAG_TYPE_RELEASE = 'release';
  PARENT_DEPENDENCY_OPERATOR_ALL = 'ALL';
  PARENT_DEPENDENCY_OPERATOR_ANY = 'ANY';
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Allocation;
  _.$_$.b = EvaluationEngineImpl;
  _.$_$.c = get_FLAG_TYPE_RELEASE;
  _.$_$.d = FlagConfig;
  _.$_$.e = ParentDependencies;
  _.$_$.f = SegmentTargetingConfig;
  _.$_$.g = UserPropertyFilter;
  _.$_$.h = Variant;
  _.$_$.i = Operator_CONTAINS_getInstance;
  _.$_$.j = Operator_CSS_MATCH_getInstance;
  _.$_$.k = Operator_DOES_NOT_CONTAIN_getInstance;
  _.$_$.l = Operator_ENDS_WITH_getInstance;
  _.$_$.m = Operator_GLOB_DOES_NOT_MATCH_getInstance;
  _.$_$.n = Operator_GLOB_MATCH_getInstance;
  _.$_$.o = Operator_GREATER_THAN_EQUALS_getInstance;
  _.$_$.p = Operator_GREATER_THAN_getInstance;
  _.$_$.q = Operator_HAS_PREFIX_getInstance;
  _.$_$.r = Operator_IS_NOT_getInstance;
  _.$_$.s = Operator_IS_getInstance;
  _.$_$.t = Operator_LESS_THAN_EQUALS_getInstance;
  _.$_$.u = Operator_LESS_THAN_getInstance;
  _.$_$.v = Operator_SET_CONTAINS_getInstance;
  _.$_$.w = Operator_SET_DOES_NOT_CONTAIN_getInstance;
  _.$_$.x = Operator_SET_IS_NOT_getInstance;
  _.$_$.y = Operator_SET_IS_getInstance;
  _.$_$.z = Operator_VERSION_GREATER_THAN_EQUALS_getInstance;
  _.$_$.a1 = Operator_VERSION_GREATER_THAN_getInstance;
  _.$_$.b1 = Operator_VERSION_LESS_THAN_EQUALS_getInstance;
  _.$_$.c1 = Operator_VERSION_LESS_THAN_getInstance;
  _.$_$.d1 = SkylabUser_init_$Create$;
  _.$_$.e1 = Keys_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=experiment-evaluation-evaluation-core.js.map
